export default __webpack_public_path__ + "static/Vendors-Sell-9a1324a28383b147d5978b3623ac05f0.jpg";